module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment03_sp-81a2f48d80f01a47e82d6d1e8052dc00.png";